var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlayQr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 153,
    height: 153,
    viewBox: "0 0 153 153",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_833_41129)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M152.02 0H0V152.02H152.02V0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1034 12.0098H12V15.1132H15.1034V12.0098Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.2068 12.0098H15.1034V15.1132H18.2068V12.0098Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.3102 12.0098H18.2068V15.1132H21.3102V12.0098Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.4137 12.0098H21.3102V15.1132H24.4137V12.0098Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.5171 12.0098H24.4137V15.1132H27.5171V12.0098Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.6205 12.0098H27.5171V15.1132H30.6205V12.0098Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.7239 12.0098H30.6205V15.1132H33.7239V12.0098Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.0341 12.0098H39.9307V15.1132H43.0341V12.0098Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.1376 12.0098H43.0341V15.1132H46.1376V12.0098Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.5512 12.0098H55.4478V15.1132H58.5512V12.0098Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.6546 12.0098H58.5512V15.1132H61.6546V12.0098Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.758 12.0098H61.6546V15.1132H64.758V12.0098Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.0683 12.0098H70.9649V15.1132H74.0683V12.0098Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.2751 12.0098H77.1717V15.1132H80.2751V12.0098Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.3785 12.0098H80.2751V15.1132H83.3785V12.0098Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.102 12.0098H101.999V15.1132H105.102V12.0098Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.206 12.0098H105.102V15.1132H108.206V12.0098Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.309 12.0098H108.206V15.1132H111.309V12.0098Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.413 12.0098H111.309V15.1132H114.413V12.0098Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.62 12.0098H117.516V15.1132H120.62V12.0098Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.723 12.0098H120.62V15.1132H123.723V12.0098Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.826 12.0098H123.723V15.1132H126.826V12.0098Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.93 12.0098H126.826V15.1132H129.93V12.0098Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.033 12.0098H129.93V15.1132H133.033V12.0098Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.137 12.0098H133.033V15.1132H136.137V12.0098Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.24 12.0098H136.137V15.1132H139.24V12.0098Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1034 15.1132H12V18.2166H15.1034V15.1132Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.7239 15.1132H30.6205V18.2166H33.7239V15.1132Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.9307 15.1132H36.8273V18.2166H39.9307V15.1132Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.1376 15.1132H43.0341V18.2166H46.1376V15.1132Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.3444 15.1132H49.241V18.2166H52.3444V15.1132Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.5512 15.1132H55.4478V18.2166H58.5512V15.1132Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.758 15.1132H61.6546V18.2166H64.758V15.1132Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.9649 15.1132H67.8615V18.2166H70.9649V15.1132Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.0683 15.1132H70.9649V18.2166H74.0683V15.1132Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.1717 15.1132H74.0683V18.2166H77.1717V15.1132Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.3785 15.1132H80.2751V18.2166H83.3785V15.1132Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.482 15.1132H83.3785V18.2166H86.482V15.1132Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.8956 15.1132H95.7922V18.2166H98.8956V15.1132Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.999 15.1132H98.8956V18.2166H101.999V15.1132Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.102 15.1132H101.999V18.2166H105.102V15.1132Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.206 15.1132H105.102V18.2166H108.206V15.1132Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.62 15.1132H117.516V18.2166H120.62V15.1132Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.24 15.1132H136.137V18.2166H139.24V15.1132Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1034 18.2166H12V21.32H15.1034V18.2166Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.3102 18.2166H18.2068V21.32H21.3102V18.2166Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.4137 18.2166H21.3102V21.32H24.4137V18.2166Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.5171 18.2166H24.4137V21.32H27.5171V18.2166Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.7239 18.2166H30.6205V21.32H33.7239V18.2166Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.0341 18.2166H39.9307V21.32H43.0341V18.2166Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.3444 18.2166H49.241V21.32H52.3444V18.2166Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.4478 18.2166H52.3444V21.32H55.4478V18.2166Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.5512 18.2166H55.4478V21.32H58.5512V18.2166Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.8615 18.2166H64.758V21.32H67.8615V18.2166Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.1717 18.2166H74.0683V21.32H77.1717V18.2166Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.3785 18.2166H80.2751V21.32H83.3785V18.2166Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.482 18.2166H83.3785V21.32H86.482V18.2166Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.7922 18.2166H92.6888V21.32H95.7922V18.2166Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.8956 18.2166H95.7922V21.32H98.8956V18.2166Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.206 18.2166H105.102V21.32H108.206V18.2166Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.309 18.2166H108.206V21.32H111.309V18.2166Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.413 18.2166H111.309V21.32H114.413V18.2166Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.62 18.2166H117.516V21.32H120.62V18.2166Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.826 18.2166H123.723V21.32H126.826V18.2166Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.93 18.2166H126.826V21.32H129.93V18.2166Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.033 18.2166H129.93V21.32H133.033V18.2166Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.24 18.2166H136.137V21.32H139.24V18.2166Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1034 21.32H12V24.4234H15.1034V21.32Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.3102 21.32H18.2068V24.4234H21.3102V21.32Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.4137 21.32H21.3102V24.4234H24.4137V21.32Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.5171 21.32H24.4137V24.4234H27.5171V21.32Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.7239 21.32H30.6205V24.4234H33.7239V21.32Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.0341 21.32H39.9307V24.4234H43.0341V21.32Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.1376 21.32H43.0341V24.4234H46.1376V21.32Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.241 21.32H46.1376V24.4234H49.241V21.32Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.3444 21.32H49.241V24.4234H52.3444V21.32Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.4478 21.32H52.3444V24.4234H55.4478V21.32Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.6546 21.32H58.5512V24.4234H61.6546V21.32Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.1717 21.32H74.0683V24.4234H77.1717V21.32Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.3785 21.32H80.2751V24.4234H83.3785V21.32Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.482 21.32H83.3785V24.4234H86.482V21.32Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.7922 21.32H92.6888V24.4234H95.7922V21.32Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.8956 21.32H95.7922V24.4234H98.8956V21.32Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.999 21.32H98.8956V24.4234H101.999V21.32Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.413 21.32H111.309V24.4234H114.413V21.32Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.62 21.32H117.516V24.4234H120.62V21.32Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.826 21.32H123.723V24.4234H126.826V21.32Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.93 21.32H126.826V24.4234H129.93V21.32Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.033 21.32H129.93V24.4234H133.033V21.32Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.24 21.32H136.137V24.4234H139.24V21.32Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1034 24.4234H12V27.5268H15.1034V24.4234Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.3102 24.4234H18.2068V27.5268H21.3102V24.4234Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.4137 24.4234H21.3102V27.5268H24.4137V24.4234Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.5171 24.4234H24.4137V27.5268H27.5171V24.4234Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.7239 24.4234H30.6205V27.5268H33.7239V24.4234Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.1376 24.4234H43.0341V27.5268H46.1376V24.4234Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.241 24.4234H46.1376V27.5268H49.241V24.4234Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.6546 24.4234H58.5512V27.5268H61.6546V24.4234Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.8615 24.4234H64.758V27.5268H67.8615V24.4234Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.9649 24.4234H67.8615V27.5268H70.9649V24.4234Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.2751 24.4234H77.1717V27.5268H80.2751V24.4234Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.3785 24.4234H80.2751V27.5268H83.3785V24.4234Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.482 24.4234H83.3785V27.5268H86.482V24.4234Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.5854 24.4234L86.482 24.4234V27.5268H89.5854V24.4234Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.7922 24.4234H92.6888V27.5268H95.7922V24.4234Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.8956 24.4234H95.7922V27.5268H98.8956V24.4234Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.999 24.4234H98.8956V27.5268H101.999V24.4234Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.102 24.4234L101.999 24.4234V27.5268H105.102V24.4234Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.206 24.4234H105.102V27.5268H108.206V24.4234Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.413 24.4234H111.309V27.5268H114.413V24.4234Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.62 24.4234H117.516V27.5268H120.62V24.4234Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.826 24.4234H123.723V27.5268H126.826V24.4234Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.93 24.4234H126.826V27.5268H129.93V24.4234Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.033 24.4234H129.93V27.5268H133.033V24.4234Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.24 24.4234H136.137V27.5268H139.24V24.4234Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1034 27.5268H12V30.6303H15.1034V27.5268Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.7239 27.5268H30.6205V30.6303H33.7239V27.5268Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.1376 27.5268H43.0341V30.6303H46.1376V27.5268Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.241 27.5268H46.1376V30.6303H49.241V27.5268Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.4478 27.5268H52.3444V30.6303H55.4478V27.5268Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.9649 27.5268H67.8615V30.6303H70.9649V27.5268Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.0683 27.5268H70.9649V30.6303H74.0683V27.5268Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.2751 27.5268H77.1717V30.6303H80.2751V27.5268Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.3785 27.5268H80.2751V30.6303H83.3785V27.5268Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.482 27.5268H83.3785V30.6303H86.482V27.5268Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.5854 27.5268H86.482V30.6303H89.5854V27.5268Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.8956 27.5268H95.7922V30.6303H98.8956V27.5268Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.999 27.5268H98.8956V30.6303H101.999V27.5268Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.206 27.5268H105.102V30.6303H108.206V27.5268Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.413 27.5268H111.309V30.6303H114.413V27.5268Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.62 27.5268H117.516V30.6303H120.62V27.5268Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.24 27.5268H136.137V30.6303H139.24V27.5268Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1034 30.6303H12V33.7337H15.1034V30.6303Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.2068 30.6303H15.1034V33.7337H18.2068V30.6303Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.3102 30.6303H18.2068V33.7337H21.3102V30.6303Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.4137 30.6303H21.3102V33.7337H24.4137V30.6303Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.5171 30.6303H24.4137V33.7337H27.5171V30.6303Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.6205 30.6303H27.5171V33.7337H30.6205V30.6303Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.7239 30.6303H30.6205V33.7337H33.7239V30.6303Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.9307 30.6303H36.8273V33.7337H39.9307V30.6303Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.1376 30.6303H43.0341V33.7337H46.1376V30.6303Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.3444 30.6303H49.241V33.7337H52.3444V30.6303Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.5512 30.6303H55.4478V33.7337H58.5512V30.6303Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.758 30.6303H61.6546V33.7337H64.758V30.6303Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.9649 30.6303H67.8615V33.7337H70.9649V30.6303Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.1717 30.6303H74.0683V33.7337H77.1717V30.6303Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.3785 30.6303H80.2751V33.7337H83.3785V30.6303Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.5854 30.6303H86.482V33.7337H89.5854V30.6303Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.7922 30.6303H92.6888V33.7337H95.7922V30.6303Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.999 30.6303H98.8956V33.7337H101.999V30.6303Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.206 30.6303H105.102V33.7337H108.206V30.6303Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.413 30.6303H111.309V33.7337H114.413V30.6303Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.62 30.6303H117.516V33.7337H120.62V30.6303Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.723 30.6303H120.62V33.7337H123.723V30.6303Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.826 30.6303H123.723V33.7337H126.826V30.6303Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.93 30.6303H126.826V33.7337H129.93V30.6303Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.033 30.6303H129.93V33.7337H133.033V30.6303Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.137 30.6303H133.033V33.7337H136.137V30.6303Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.24 30.6303H136.137V33.7337H139.24V30.6303Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.9307 33.7337H36.8273V36.8371H39.9307V33.7337Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.0341 33.7337H39.9307V36.8371H43.0341V33.7337Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.1376 33.7337H43.0341V36.8371H46.1376V33.7337Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.241 33.7337H46.1376V36.8371H49.241V33.7337Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.4478 33.7337H52.3444V36.8371H55.4478V33.7337Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.5512 33.7337H55.4478V36.8371H58.5512V33.7337Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.6546 33.7337H58.5512V36.8371H61.6546V33.7337Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.758 33.7337H61.6546V36.8371H64.758V33.7337Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.8615 33.7337H64.758V36.8371H67.8615V33.7337Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.3785 33.7337H80.2751V36.8371H83.3785V33.7337Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.482 33.7337H83.3785V36.8371H86.482V33.7337Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.6888 33.7337H89.5854V36.8371H92.6888V33.7337Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.7922 33.7337H92.6888V36.8371H95.7922V33.7337Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.102 33.7337H101.999V36.8371H105.102V33.7337Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.309 33.7337H108.206V36.8371H111.309V33.7337Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1034 36.8371H12V39.9405H15.1034V36.8371Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.2068 36.8371H15.1034V39.9405H18.2068V36.8371Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.7239 36.8371H30.6205V39.9405H33.7239V36.8371Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.9307 36.8371H36.8273V39.9405H39.9307V36.8371Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.241 36.8371H46.1376V39.9405H49.241V36.8371Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.3444 36.8371H49.241V39.9405H52.3444V36.8371Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.4478 36.8371H52.3444V39.9405H55.4478V36.8371Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.5512 36.8371H55.4478V39.9405H58.5512V36.8371Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.6546 36.8371H58.5512V39.9405H61.6546V36.8371Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.8615 36.8371H64.758V39.9405H67.8615V36.8371Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.0683 36.8371H70.9649V39.9405H74.0683V36.8371Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.1717 36.8371H74.0683V39.9405H77.1717V36.8371Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.2751 36.8371H77.1717V39.9405H80.2751V36.8371Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.3785 36.8371H80.2751V39.9405H83.3785V36.8371Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.5854 36.8371H86.482V39.9405H89.5854V36.8371Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.6888 36.8371H89.5854V39.9405H92.6888V36.8371Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.7922 36.8371H92.6888V39.9405H95.7922V36.8371Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.8956 36.8371H95.7922V39.9405H98.8956V36.8371Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.999 36.8371H98.8956V39.9405H101.999V36.8371Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.102 36.8371H101.999V39.9405H105.102V36.8371Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.309 36.8371H108.206V39.9405H111.309V36.8371Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.413 36.8371H111.309V39.9405H114.413V36.8371Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.516 36.8371H114.413V39.9405H117.516V36.8371Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.62 36.8371H117.516V39.9405H120.62V36.8371Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.137 36.8371H133.033V39.9405H136.137V36.8371Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1034 39.9405H12V43.0439H15.1034V39.9405Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.3102 39.9405H18.2068V43.0439H21.3102V39.9405Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.4137 39.9405H21.3102V43.0439H24.4137V39.9405Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.6205 39.9405H27.5171V43.0439H30.6205V39.9405Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.9307 39.9405H36.8273V43.0439H39.9307V39.9405Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.0341 39.9405H39.9307V43.0439H43.0341V39.9405Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.3444 39.9405H49.241V43.0439H52.3444V39.9405Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.4478 39.9405H52.3444V43.0439H55.4478V39.9405Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.758 39.9405H61.6546V43.0439H64.758V39.9405Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.9649 39.9405H67.8615V43.0439H70.9649V39.9405Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.0683 39.9405H70.9649V43.0439H74.0683V39.9405Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.5854 39.9405H86.482V43.0439H89.5854V39.9405Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.999 39.9405H98.8956V43.0439H101.999V39.9405Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.309 39.9405H108.206V43.0439H111.309V39.9405Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.62 39.9405H117.516V43.0439H120.62V39.9405Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.723 39.9405H120.62V43.0439H123.723V39.9405Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.826 39.9405H123.723V43.0439H126.826V39.9405Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.93 39.9405H126.826V43.0439H129.93V39.9405Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.137 39.9405H133.033V43.0439H136.137V39.9405Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.24 39.9405H136.137V43.0439H139.24V39.9405Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.6205 43.0439H27.5171V46.1473H30.6205V43.0439Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.7239 43.0439H30.6205V46.1473H33.7239V43.0439Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.8273 43.0439H33.7239V46.1473H36.8273V43.0439Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.9307 43.0439H36.8273V46.1473H39.9307V43.0439Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.1376 43.0439H43.0341V46.1473H46.1376V43.0439Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.241 43.0439H46.1376V46.1473H49.241V43.0439Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.6546 43.0439H58.5512V46.1473H61.6546V43.0439Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.758 43.0439H61.6546V46.1473H64.758V43.0439Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.9649 43.0439H67.8615V46.1473H70.9649V43.0439Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.0683 43.0439H70.9649V46.1473H74.0683V43.0439Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.2751 43.0439H77.1717V46.1473H80.2751V43.0439Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.3785 43.0439H80.2751V46.1473H83.3785V43.0439Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.482 43.0439H83.3785V46.1473H86.482V43.0439Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.5854 43.0439H86.482V46.1473H89.5854V43.0439Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.999 43.0439H98.8956V46.1473H101.999V43.0439Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.102 43.0439H101.999V46.1473H105.102V43.0439Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.516 43.0439H114.413V46.1473H117.516V43.0439Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.62 43.0439H117.516V46.1473H120.62V43.0439Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.826 43.0439H123.723V46.1473H126.826V43.0439Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.93 43.0439H126.826V46.1473H129.93V43.0439Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.24 43.0439H136.137V46.1473H139.24V43.0439Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.3102 46.1473H18.2068V49.2507H21.3102V46.1473Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.4137 46.1473H21.3102V49.2507H24.4137V46.1473Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.5171 46.1473H24.4137V49.2507H27.5171V46.1473Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.9307 46.1473H36.8273V49.2507H39.9307V46.1473Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.0341 46.1473H39.9307V49.2507H43.0341V46.1473Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.1376 46.1473H43.0341V49.2507H46.1376V46.1473Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.4478 46.1473H52.3444V49.2507H55.4478V46.1473Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.5512 46.1473H55.4478V49.2507H58.5512V46.1473Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.2751 46.1473H77.1717V49.2507H80.2751V46.1473Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.482 46.1473H83.3785V49.2507H86.482V46.1473Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.7922 46.1473H92.6888V49.2507H95.7922V46.1473Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.8956 46.1473H95.7922V49.2507H98.8956V46.1473Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.102 46.1473H101.999V49.2507H105.102V46.1473Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.206 46.1473H105.102V49.2507H108.206V46.1473Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.723 46.1473H120.62V49.2507H123.723V46.1473Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.93 46.1473H126.826V49.2507H129.93V46.1473Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.033 46.1473H129.93V49.2507H133.033V46.1473Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1034 49.2507H12V52.3542H15.1034V49.2507Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.3102 49.2507H18.2068V52.3542H21.3102V49.2507Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.5171 49.2507H24.4137L24.4137 52.3542H27.5171V49.2507Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.7239 49.2507H30.6205V52.3542H33.7239V49.2507Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.8273 49.2507H33.7239V52.3542H36.8273V49.2507Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.9307 49.2507H36.8273V52.3542H39.9307V49.2507Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.0341 49.2507H39.9307V52.3542H43.0341V49.2507Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.1376 49.2507H43.0341V52.3542H46.1376V49.2507Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.241 49.2507H46.1376V52.3542H49.241V49.2507Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.4478 49.2507H52.3444V52.3542H55.4478V49.2507Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.1717 49.2507H74.0683V52.3542H77.1717V49.2507Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.2751 49.2507H77.1717V52.3542H80.2751V49.2507Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.6888 49.2507H89.5854V52.3542H92.6888V49.2507Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.7922 49.2507H92.6888V52.3542H95.7922V49.2507Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.999 49.2507H98.8956V52.3542H101.999V49.2507Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.206 49.2507H105.102V52.3542H108.206V49.2507Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.309 49.2507H108.206V52.3542H111.309V49.2507Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.516 49.2507H114.413V52.3542H117.516V49.2507Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.93 49.2507H126.826V52.3542H129.93V49.2507Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.137 49.2507H133.033V52.3542H136.137V49.2507Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1034 52.3542H12V55.4576H15.1034V52.3542Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.2068 52.3542H15.1034V55.4576H18.2068V52.3542Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.3102 52.3542H18.2068V55.4576H21.3102V52.3542Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.6205 52.3542H27.5171V55.4576H30.6205V52.3542Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.1376 52.3542H43.0341V55.4576H46.1376V52.3542Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.4478 52.3542H52.3444V55.4576H55.4478V52.3542Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.5512 52.3542H55.4478V55.4576H58.5512V52.3542Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.758 52.3542H61.6546V55.4576H64.758V52.3542Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.8615 52.3542H64.758V55.4576H67.8615V52.3542Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.9649 52.3542H67.8615V55.4576H70.9649V52.3542Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.0683 52.3542H70.9649V55.4576H74.0683V52.3542Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.1717 52.3542H74.0683V55.4576H77.1717V52.3542Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.2751 52.3542H77.1717V55.4576H80.2751V52.3542Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.482 52.3542H83.3785V55.4576H86.482V52.3542Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.5854 52.3542H86.482V55.4576H89.5854V52.3542Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.7922 52.3542H92.6888V55.4576H95.7922V52.3542Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.8956 52.3542H95.7922V55.4576H98.8956V52.3542Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.206 52.3542H105.102V55.4576H108.206V52.3542Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.93 52.3542H126.826V55.4576H129.93V52.3542Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.137 52.3542H133.033V55.4576H136.137V52.3542Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.24 52.3542H136.137V55.4576H139.24V52.3542Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1034 55.4576H12V58.561H15.1034V55.4576Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.4137 55.4576H21.3102V58.561H24.4137V55.4576Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.5171 55.4576H24.4137V58.561H27.5171V55.4576Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.7239 55.4576H30.6205V58.561H33.7239V55.4576Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.8273 55.4576H33.7239V58.561H36.8273V55.4576Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.9307 55.4576H36.8273V58.561H39.9307V55.4576Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.0341 55.4576H39.9307V58.561H43.0341V55.4576Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.1376 55.4576H43.0341V58.561H46.1376V55.4576Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.241 55.4576H46.1376V58.561H49.241V55.4576Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.5512 55.4576H55.4478V58.561H58.5512V55.4576Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.758 55.4576H61.6546V58.561H64.758V55.4576Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.9649 55.4576H67.8615V58.561H70.9649V55.4576Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.1717 55.4576H74.0683V58.561H77.1717V55.4576Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.482 55.4576H83.3785V58.561H86.482V55.4576Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.5854 55.4576H86.482V58.561H89.5854V55.4576Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.8956 55.4576H95.7922V58.561H98.8956V55.4576Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.999 55.4576H98.8956V58.561H101.999V55.4576Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.516 55.4576H114.413V58.561H117.516V55.4576Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.62 55.4576H117.516V58.561H120.62V55.4576Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.033 55.4576H129.93V58.561H133.033V55.4576Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1034 58.561H12V61.6644H15.1034V58.561Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.3102 58.561H18.2068V61.6644H21.3102V58.561Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.5171 58.561H24.4137L24.4137 61.6644H27.5171V58.561Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.0341 58.561H39.9307V61.6644H43.0341V58.561Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.1376 58.561H43.0341V61.6644H46.1376V58.561Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.3444 58.561H49.241V61.6644H52.3444V58.561Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.5512 58.561H55.4478V61.6644H58.5512V58.561Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.9649 58.561H67.8615V61.6644H70.9649V58.561Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.0683 58.561H70.9649V61.6644H74.0683V58.561Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.2751 58.561H77.1717V61.6644H80.2751V58.561Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.5854 58.561H86.482V61.6644H89.5854V58.561Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.7922 58.561H92.6888V61.6644H95.7922V58.561Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.8956 58.561H95.7922V61.6644H98.8956V58.561Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.999 58.561H98.8956V61.6644H101.999V58.561Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.102 58.561H101.999V61.6644H105.102V58.561Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.206 58.561H105.102V61.6644H108.206V58.561Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.309 58.561H108.206V61.6644H111.309V58.561Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.516 58.561H114.413V61.6644H117.516V58.561Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.62 58.561H117.516V61.6644H120.62V58.561Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.723 58.561H120.62V61.6644H123.723V58.561Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.826 58.561H123.723V61.6644H126.826V58.561Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.93 58.561H126.826V61.6644H129.93V58.561Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.033 58.561H129.93V61.6644H133.033V58.561Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.137 58.561H133.033V61.6644H136.137V58.561Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.24 58.561H136.137V61.6644H139.24V58.561Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.3102 61.6644H18.2068V64.7678H21.3102V61.6644Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.5171 61.6644H24.4137V64.7678H27.5171V61.6644Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.6205 61.6644H27.5171V64.7678H30.6205V61.6644Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.7239 61.6644H30.6205V64.7678H33.7239V61.6644Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.8273 61.6644H33.7239V64.7678H36.8273V61.6644Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.9307 61.6644H36.8273V64.7678H39.9307V61.6644Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.1376 61.6644H43.0341V64.7678H46.1376V61.6644Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.3444 61.6644H49.241V64.7678H52.3444V61.6644Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.4478 61.6644H52.3444V64.7678H55.4478V61.6644Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.5512 61.6644H55.4478V64.7678H58.5512V61.6644Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.9649 61.6644H67.8615V64.7678H70.9649V61.6644Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.0683 61.6644H70.9649V64.7678H74.0683V61.6644Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.3785 61.6644H80.2751V64.7678H83.3785V61.6644Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.482 61.6644H83.3785V64.7678H86.482V61.6644Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.5854 61.6644H86.482V64.7678H89.5854V61.6644Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.6888 61.6644H89.5854V64.7678H92.6888V61.6644Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.8956 61.6644H95.7922V64.7678H98.8956V61.6644Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.999 61.6644H98.8956V64.7678H101.999V61.6644Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.309 61.6644H108.206V64.7678H111.309V61.6644Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.516 61.6644H114.413V64.7678H117.516V61.6644Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.62 61.6644H117.516V64.7678H120.62V61.6644Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.723 61.6644H120.62V64.7678H123.723V61.6644Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.93 61.6644H126.826V64.7678H129.93V61.6644Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.033 61.6644H129.93V64.7678H133.033V61.6644Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1034 64.7678H12V67.8712H15.1034V64.7678Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.2068 64.7678H15.1034V67.8712H18.2068V64.7678Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.3102 64.7678H18.2068V67.8712H21.3102V64.7678Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.4137 64.7678H21.3102V67.8712H24.4137L24.4137 64.7678Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.6205 64.7678H27.5171V67.8712H30.6205V64.7678Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.9307 64.7678H36.8273V67.8712H39.9307V64.7678Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.0341 64.7678H39.9307V67.8712H43.0341V64.7678Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.241 64.7678H46.1376V67.8712H49.241V64.7678Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.3444 64.7678H49.241V67.8712H52.3444V64.7678Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.4478 64.7678H52.3444V67.8712H55.4478V64.7678Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.5512 64.7678H55.4478V67.8712H58.5512V64.7678Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.6546 64.7678H58.5512V67.8712H61.6546V64.7678Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.758 64.7678H61.6546V67.8712H64.758V64.7678Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.8615 64.7678H64.758V67.8712H67.8615V64.7678Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.9649 64.7678H67.8615V67.8712H70.9649V64.7678Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.2751 64.7678H77.1717V67.8712H80.2751V64.7678Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.3785 64.7678H80.2751V67.8712H83.3785V64.7678Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.482 64.7678H83.3785V67.8712H86.482V64.7678Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.6888 64.7678H89.5854V67.8712H92.6888V64.7678Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.102 64.7678H101.999V67.8712H105.102V64.7678Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.206 64.7678H105.102V67.8712H108.206V64.7678Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.516 64.7678H114.413V67.8712H117.516V64.7678Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.93 64.7678H126.826V67.8712H129.93V64.7678Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.137 64.7678H133.033V67.8712H136.137V64.7678Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1034 67.8712H12V70.9746H15.1034V67.8712Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.2068 67.8712H15.1034V70.9746H18.2068V67.8712Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.7239 67.8712H30.6205V70.9746H33.7239V67.8712Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.9307 67.8712H36.8273V70.9746H39.9307V67.8712Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.1376 67.8712H43.0341V70.9746H46.1376V67.8712Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.241 67.8712H46.1376V70.9746H49.241V67.8712Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.4478 67.8712H52.3444V70.9746H55.4478V67.8712Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.5512 67.8712H55.4478V70.9746H58.5512V67.8712Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.758 67.8712H61.6546V70.9746H64.758V67.8712Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.0683 67.8712H70.9649V70.9746H74.0683V67.8712Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.1717 67.8712H74.0683V70.9746H77.1717V67.8712Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.3785 67.8712H80.2751V70.9746H83.3785V67.8712Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.5854 67.8712H86.482V70.9746H89.5854V67.8712Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.6888 67.8712H89.5854V70.9746H92.6888V67.8712Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.7922 67.8712H92.6888V70.9746H95.7922V67.8712Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.8956 67.8712H95.7922V70.9746H98.8956V67.8712Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.102 67.8712H101.999V70.9746H105.102V67.8712Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.206 67.8712H105.102V70.9746H108.206V67.8712Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.413 67.8712H111.309V70.9746H114.413V67.8712Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.516 67.8712H114.413V70.9746H117.516V67.8712Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.62 67.8712H117.516V70.9746H120.62V67.8712Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.24 67.8712H136.137V70.9746H139.24V67.8712Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1034 70.9746H12V74.0781H15.1034V70.9746Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.3102 70.9746H18.2068V74.0781H21.3102V70.9746Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.4137 70.9746H21.3102V74.0781H24.4137V70.9746Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.1376 70.9746H43.0341V74.0781H46.1376V70.9746Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.241 70.9746H46.1376V74.0781H49.241V70.9746Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.6546 70.9746H58.5512V74.0781H61.6546V70.9746Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.8615 70.9746H64.758V74.0781H67.8615V70.9746Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.9649 70.9746H67.8615V74.0781H70.9649V70.9746Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.1717 70.9746H74.0683V74.0781H77.1717V70.9746Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.3785 70.9746H80.2751V74.0781H83.3785V70.9746Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.482 70.9746H83.3785V74.0781H86.482V70.9746Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.7922 70.9746H92.6888V74.0781H95.7922V70.9746Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.102 70.9746H101.999V74.0781H105.102V70.9746Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.309 70.9746H108.206V74.0781H111.309V70.9746Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.516 70.9746H114.413V74.0781H117.516V70.9746Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.62 70.9746H117.516V74.0781H120.62V70.9746Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.723 70.9746H120.62V74.0781H123.723V70.9746Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.826 70.9746H123.723V74.0781H126.826V70.9746Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.033 70.9746H129.93V74.0781H133.033V70.9746Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1034 74.0781H12V77.1815H15.1034V74.0781Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.2068 74.0781H15.1034V77.1815H18.2068V74.0781Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.3102 74.0781H18.2068V77.1815H21.3102V74.0781Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.6205 74.0781H27.5171V77.1815H30.6205V74.0781Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.7239 74.0781H30.6205V77.1815H33.7239V74.0781Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.8273 74.0781H33.7239V77.1815H36.8273V74.0781Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.0341 74.0781H39.9307V77.1815H43.0341V74.0781Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.1376 74.0781H43.0341V77.1815H46.1376V74.0781Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.3444 74.0781H49.241V77.1815H52.3444V74.0781Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.5512 74.0781H55.4478V77.1815H58.5512V74.0781Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.6546 74.0781H58.5512V77.1815H61.6546V74.0781Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.8615 74.0781H64.758V77.1815H67.8615V74.0781Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.0683 74.0781H70.9649V77.1815H74.0683V74.0781Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.1717 74.0781H74.0683V77.1815H77.1717V74.0781Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.482 74.0781H83.3785V77.1815H86.482V74.0781Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.5854 74.0781H86.482V77.1815H89.5854V74.0781Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.7922 74.0781H92.6888V77.1815H95.7922V74.0781Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.8956 74.0781H95.7922V77.1815H98.8956V74.0781Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.206 74.0781H105.102V77.1815H108.206V74.0781Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.723 74.0781H120.62V77.1815H123.723V74.0781Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.826 74.0781H123.723V77.1815H126.826V74.0781Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.93 74.0781H126.826V77.1815H129.93V74.0781Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.137 74.0781H133.033V77.1815H136.137V74.0781Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.24 74.0781H136.137V77.1815H139.24V74.0781Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1034 77.1815H12V80.2849H15.1034V77.1815Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.4137 77.1815H21.3102V80.2849H24.4137V77.1815Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.5171 77.1815H24.4137V80.2849H27.5171V77.1815Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.6205 77.1815H27.5171V80.2849H30.6205V77.1815Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.9307 77.1815H36.8273V80.2849H39.9307V77.1815Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.0341 77.1815H39.9307V80.2849H43.0341V77.1815Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.1376 77.1815H43.0341V80.2849H46.1376V77.1815Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.241 77.1815H46.1376V80.2849H49.241V77.1815Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.3444 77.1815H49.241V80.2849H52.3444V77.1815Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.4478 77.1815H52.3444V80.2849H55.4478V77.1815Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.5512 77.1815H55.4478V80.2849H58.5512V77.1815Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.8615 77.1815H64.758V80.2849H67.8615V77.1815Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.9649 77.1815H67.8615V80.2849H70.9649V77.1815Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.0683 77.1815H70.9649V80.2849H74.0683V77.1815Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.2751 77.1815H77.1717V80.2849H80.2751V77.1815Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.482 77.1815H83.3785V80.2849H86.482V77.1815Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.6888 77.1815H89.5854V80.2849H92.6888V77.1815Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.7922 77.1815H92.6888V80.2849H95.7922V77.1815Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.8956 77.1815H95.7922V80.2849H98.8956V77.1815Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.999 77.1815H98.8956V80.2849H101.999V77.1815Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.102 77.1815H101.999V80.2849H105.102V77.1815Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.206 77.1815H105.102V80.2849H108.206V77.1815Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.62 77.1815H117.516V80.2849H120.62V77.1815Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.826 77.1815H123.723V80.2849H126.826V77.1815Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.033 77.1815H129.93V80.2849H133.033V77.1815Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.137 77.1815H133.033V80.2849H136.137V77.1815Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.2068 80.2849H15.1034V83.3883H18.2068V80.2849Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.3102 80.2849H18.2068V83.3883H21.3102V80.2849Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.5171 80.2849H24.4137L24.4137 83.3883H27.5171V80.2849Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.6205 80.2849H27.5171V83.3883H30.6205V80.2849Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.7239 80.2849H30.6205V83.3883H33.7239V80.2849Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.0341 80.2849H39.9307V83.3883H43.0341V80.2849Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.3444 80.2849H49.241V83.3883H52.3444V80.2849Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.5512 80.2849H55.4478V83.3883H58.5512V80.2849Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.8615 80.2849H64.758V83.3883H67.8615V80.2849Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.0683 80.2849H70.9649V83.3883H74.0683V80.2849Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.1717 80.2849H74.0683V83.3883H77.1717V80.2849Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.2751 80.2849H77.1717V83.3883H80.2751V80.2849Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.482 80.2849H83.3785V83.3883H86.482V80.2849Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.6888 80.2849H89.5854V83.3883H92.6888V80.2849Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.7922 80.2849H92.6888V83.3883H95.7922V80.2849Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.8956 80.2849H95.7922V83.3883H98.8956V80.2849Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.206 80.2849H105.102V83.3883H108.206V80.2849Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.309 80.2849H108.206V83.3883H111.309V80.2849Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.413 80.2849H111.309V83.3883H114.413V80.2849Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.62 80.2849H117.516V83.3883H120.62V80.2849Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.826 80.2849H123.723V83.3883H126.826V80.2849Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.93 80.2849H126.826V83.3883H129.93V80.2849Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.2068 83.3883H15.1034V86.4917H18.2068V83.3883Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.3102 83.3883H18.2068V86.4917H21.3102V83.3883Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.5171 83.3883H24.4137V86.4917H27.5171V83.3883Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.6205 83.3883H27.5171V86.4917H30.6205V83.3883Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.9307 83.3883H36.8273V86.4917H39.9307V83.3883Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.0341 83.3883H39.9307V86.4917H43.0341V83.3883Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.1376 83.3883H43.0341V86.4917H46.1376V83.3883Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.241 83.3883H46.1376V86.4917H49.241V83.3883Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.3444 83.3883H49.241V86.4917H52.3444V83.3883Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.5512 83.3883H55.4478V86.4917H58.5512V83.3883Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.6546 83.3883H58.5512V86.4917H61.6546V83.3883Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.758 83.3883H61.6546V86.4917H64.758V83.3883Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.8615 83.3883H64.758V86.4917H67.8615V83.3883Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.9649 83.3883H67.8615V86.4917H70.9649V83.3883Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.0683 83.3883H70.9649V86.4917H74.0683V83.3883Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.1717 83.3883H74.0683V86.4917H77.1717V83.3883Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.2751 83.3883H77.1717V86.4917H80.2751V83.3883Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.5854 83.3883H86.482V86.4917H89.5854V83.3883Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.6888 83.3883H89.5854V86.4917H92.6888V83.3883Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.8956 83.3883H95.7922V86.4917H98.8956V83.3883Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.206 83.3883H105.102V86.4917H108.206V83.3883Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.516 83.3883H114.413V86.4917H117.516V83.3883Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.826 83.3883H123.723V86.4917H126.826V83.3883Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.93 83.3883H126.826V86.4917H129.93V83.3883Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.137 83.3883H133.033V86.4917H136.137V83.3883Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.24 83.3883H136.137V86.4917H139.24V83.3883Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.2068 86.4917H15.1034V89.5951H18.2068V86.4917Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.5171 86.4917H24.4137V89.5951H27.5171V86.4917Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.6205 86.4917H27.5171V89.5951H30.6205V86.4917Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.7239 86.4917H30.6205V89.5951H33.7239V86.4917Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.1376 86.4917H43.0341V89.5951H46.1376V86.4917Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.3444 86.4917H49.241V89.5951H52.3444V86.4917Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.5512 86.4917H55.4478V89.5951H58.5512V86.4917Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.758 86.4917H61.6546V89.5951H64.758V86.4917Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.1717 86.4917H74.0683V89.5951H77.1717V86.4917Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.3785 86.4917H80.2751V89.5951H83.3785V86.4917Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.5854 86.4917H86.482V89.5951H89.5854V86.4917Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.102 86.4917H101.999V89.5951H105.102V86.4917Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.309 86.4917H108.206V89.5951H111.309V86.4917Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.413 86.4917H111.309V89.5951H114.413V86.4917Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.62 86.4917H117.516V89.5951H120.62V86.4917Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.723 86.4917H120.62V89.5951H123.723V86.4917Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.826 86.4917H123.723V89.5951H126.826V86.4917Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.24 86.4917H136.137V89.5951H139.24V86.4917Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.2068 89.5951H15.1034V92.6985H18.2068V89.5951Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.3102 89.5951H18.2068V92.6985H21.3102V89.5951Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.6205 89.5951H27.5171V92.6985H30.6205V89.5951Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.9307 89.5951H36.8273V92.6985H39.9307V89.5951Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.4478 89.5951H52.3444V92.6985H55.4478V89.5951Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.758 89.5951H61.6546V92.6985H64.758V89.5951Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.9649 89.5951H67.8615V92.6985H70.9649V89.5951Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.2751 89.5951H77.1717V92.6985H80.2751V89.5951Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.3785 89.5951H80.2751V92.6985H83.3785V89.5951Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.7922 89.5951H92.6888V92.6985H95.7922V89.5951Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.999 89.5951H98.8956V92.6985H101.999V89.5951Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.206 89.5951H105.102V92.6985H108.206V89.5951Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.413 89.5951H111.309V92.6985H114.413V89.5951Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.516 89.5951H114.413V92.6985H117.516V89.5951Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.62 89.5951H117.516V92.6985H120.62V89.5951Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.723 89.5951H120.62V92.6985H123.723V89.5951Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.826 89.5951H123.723V92.6985H126.826V89.5951Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.93 89.5951H126.826V92.6985H129.93V89.5951Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.033 89.5951H129.93V92.6985H133.033V89.5951Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.24 89.5951H136.137V92.6985H139.24V89.5951Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1034 92.6985H12V95.802H15.1034V92.6985Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.2068 92.6985H15.1034V95.802H18.2068V92.6985Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.6205 92.6985H27.5171V95.802H30.6205V92.6985Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.7239 92.6985H30.6205V95.802H33.7239V92.6985Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.8273 92.6985H33.7239V95.802H36.8273V92.6985Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.9307 92.6985H36.8273V95.802H39.9307V92.6985Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.0341 92.6985H39.9307V95.802H43.0341V92.6985Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.4478 92.6985H52.3444V95.802H55.4478V92.6985Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.5512 92.6985H55.4478V95.802H58.5512V92.6985Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.6546 92.6985H58.5512V95.802H61.6546V92.6985Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.758 92.6985H61.6546V95.802H64.758V92.6985Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.8615 92.6985H64.758V95.802H67.8615V92.6985Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.9649 92.6985H67.8615V95.802H70.9649V92.6985Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.0683 92.6985H70.9649V95.802H74.0683V92.6985Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.3785 92.6985H80.2751V95.802H83.3785V92.6985Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.482 92.6985H83.3785V95.802H86.482V92.6985Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.309 92.6985H108.206V95.802H111.309V92.6985Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.413 92.6985H111.309V95.802H114.413V92.6985Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.62 92.6985H117.516V95.802H120.62V92.6985Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.033 92.6985H129.93V95.802H133.033V92.6985Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.24 92.6985H136.137V95.802H139.24V92.6985Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.9307 95.802H36.8273V98.9054H39.9307V95.802Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.0341 95.802H39.9307V98.9054H43.0341V95.802Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.1376 95.802H43.0341V98.9054H46.1376V95.802Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.241 95.802H46.1376V98.9054H49.241V95.802Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.5512 95.802H55.4478V98.9054H58.5512V95.802Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.758 95.802H61.6546V98.9054H64.758V95.802Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.8615 95.802H64.758V98.9054H67.8615V95.802Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.9649 95.802H67.8615V98.9054H70.9649V95.802Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.0683 95.802H70.9649V98.9054H74.0683V95.802Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.2751 95.802H77.1717V98.9054H80.2751V95.802Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.3785 95.802H80.2751V98.9054H83.3785V95.802Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.5854 95.802H86.482V98.9054H89.5854V95.802Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.6888 95.802H89.5854V98.9054H92.6888V95.802Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.7922 95.802H92.6888V98.9054H95.7922V95.802Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.309 95.802H108.206V98.9054H111.309V95.802Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.516 95.802H114.413V98.9054H117.516V95.802Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.62 95.802H117.516V98.9054H120.62V95.802Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.93 95.802H126.826V98.9054H129.93V95.802Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.033 95.802H129.93V98.9054H133.033V95.802Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.137 95.802H133.033V98.9054H136.137V95.802Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.5171 98.9054H24.4137V102.009H27.5171V98.9054Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.7239 98.9054H30.6205V102.009H33.7239V98.9054Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.241 98.9054H46.1376V102.009H49.241V98.9054Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.5512 98.9054H55.4478V102.009H58.5512V98.9054Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.6546 98.9054H58.5512V102.009H61.6546V98.9054Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.8615 98.9054H64.758V102.009H67.8615V98.9054Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.9649 98.9054H67.8615V102.009H70.9649V98.9054Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.0683 98.9054H70.9649V102.009H74.0683V98.9054Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.1717 98.9054H74.0683V102.009H77.1717V98.9054Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.3785 98.9054H80.2751V102.009H83.3785V98.9054Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.5854 98.9054H86.482V102.009H89.5854V98.9054Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.7922 98.9054H92.6888V102.009H95.7922V98.9054Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.8956 98.9054H95.7922V102.009H98.8956V98.9054Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.102 98.9054H101.999V102.009H105.102V98.9054Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.206 98.9054H105.102V102.009H108.206V98.9054Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.309 98.9054H108.206V102.009H111.309V98.9054Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.516 98.9054H114.413V102.009H117.516V98.9054Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.62 98.9054H117.516V102.009H120.62V98.9054Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.723 98.9054H120.62V102.009H123.723V98.9054Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.826 98.9054H123.723V102.009H126.826V98.9054Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.93 98.9054H126.826V102.009H129.93V98.9054Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.033 98.9054H129.93V102.009H133.033V98.9054Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.24 98.9054H136.137V102.009H139.24V98.9054Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1034 102.009H12V105.112H15.1034V102.009Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.9307 102.009H36.8273V105.112H39.9307V102.009Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.1376 102.009H43.0341V105.112H46.1376V102.009Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.5512 102.009H55.4478V105.112H58.5512V102.009Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.758 102.009H61.6546V105.112H64.758V102.009Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.8615 102.009H64.758V105.112H67.8615V102.009Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.0683 102.009H70.9649V105.112H74.0683V102.009Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.2751 102.009H77.1717V105.112H80.2751V102.009Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.999 102.009H98.8956V105.112H101.999V102.009Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.102 102.009H101.999V105.112H105.102V102.009Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.413 102.009H111.309V105.112H114.413V102.009Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.826 102.009H123.723V105.112H126.826V102.009Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.24 102.009H136.137V105.112H139.24V102.009Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1034 105.112H12V108.216H15.1034V105.112Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.2068 105.112H15.1034V108.216H18.2068V105.112Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.4137 105.112H21.3102V108.216H24.4137V105.112Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.6205 105.112H27.5171V108.216H30.6205V105.112Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.7239 105.112H30.6205V108.216H33.7239V105.112Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.8273 105.112H33.7239V108.216H36.8273V105.112Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.0341 105.112H39.9307V108.216H43.0341V105.112Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.1376 105.112H43.0341V108.216H46.1376V105.112Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.241 105.112H46.1376V108.216H49.241V105.112Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.4478 105.112H52.3444V108.216H55.4478V105.112Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.5512 105.112H55.4478V108.216H58.5512V105.112Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.8615 105.112H64.758V108.216H67.8615V105.112Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.0683 105.112H70.9649V108.216H74.0683V105.112Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.2751 105.112H77.1717V108.216H80.2751V105.112Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.482 105.112H83.3785V108.216H86.482V105.112Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.6888 105.112H89.5854V108.216H92.6888V105.112Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.999 105.112H98.8956V108.216H101.999V105.112Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.102 105.112H101.999V108.216H105.102V105.112Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.516 105.112H114.413V108.216H117.516V105.112Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.62 105.112H117.516V108.216H120.62V105.112Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.826 105.112H123.723V108.216H126.826V105.112Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.033 105.112H129.93V108.216H133.033V105.112Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.4137 108.216H21.3102V111.319H24.4137V108.216Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.5171 108.216H24.4137V111.319H27.5171V108.216Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.8273 108.216H33.7239V111.319H36.8273V108.216Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.9307 108.216H36.8273V111.319H39.9307V108.216Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.0341 108.216H39.9307V111.319H43.0341V108.216Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.241 108.216H46.1376V111.319H49.241V108.216Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.5512 108.216H55.4478V111.319H58.5512V108.216Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.6546 108.216H58.5512V111.319H61.6546V108.216Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.758 108.216H61.6546V111.319H64.758V108.216Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.8615 108.216H64.758V111.319H67.8615V108.216Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.9649 108.216H67.8615V111.319H70.9649V108.216Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.2751 108.216H77.1717V111.319H80.2751V108.216Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.5854 108.216H86.482V111.319H89.5854V108.216Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.6888 108.216H89.5854V111.319H92.6888V108.216Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.8956 108.216H95.7922V111.319H98.8956V108.216Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.999 108.216H98.8956V111.319H101.999V108.216Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.206 108.216H105.102V111.319H108.206V108.216Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.62 108.216H117.516V111.319H120.62V108.216Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.723 108.216H120.62V111.319H123.723V108.216Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.826 108.216H123.723V111.319H126.826V108.216Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.93 108.216H126.826V111.319H129.93V108.216Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.137 108.216H133.033V111.319H136.137V108.216Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.24 108.216H136.137V111.319H139.24V108.216Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.2068 111.319H15.1034V114.422H18.2068V111.319Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.3102 111.319H18.2068V114.422H21.3102V111.319Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.5171 111.319H24.4137L24.4137 114.422H27.5171V111.319Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.6205 111.319H27.5171V114.422H30.6205V111.319Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.7239 111.319H30.6205V114.422H33.7239V111.319Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.8273 111.319H33.7239V114.422H36.8273V111.319Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.9307 111.319H36.8273V114.422H39.9307V111.319Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.1376 111.319H43.0341V114.422H46.1376V111.319Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.241 111.319H46.1376V114.422H49.241V111.319Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.3444 111.319H49.241V114.422H52.3444V111.319Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.4478 111.319H52.3444V114.422H55.4478V111.319Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.758 111.319H61.6546V114.422H64.758V111.319Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.9649 111.319H67.8615V114.422H70.9649V111.319Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.0683 111.319H70.9649V114.422H74.0683V111.319Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.482 111.319H83.3785V114.422H86.482V111.319Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.5854 111.319H86.482V114.422H89.5854V111.319Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.7922 111.319H92.6888V114.422H95.7922V111.319Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.309 111.319H108.206V114.422H111.309V111.319Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.413 111.319H111.309V114.422H114.413V111.319Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.516 111.319H114.413V114.422H117.516V111.319Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.62 111.319H117.516V114.422H120.62V111.319Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.723 111.319H120.62V114.422H123.723V111.319Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.826 111.319H123.723V114.422H126.826V111.319Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.033 111.319H129.93V114.422H133.033V111.319Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.9307 114.422H36.8273V117.526H39.9307V114.422Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.0341 114.422H39.9307V117.526H43.0341V114.422Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.1376 114.422H43.0341V117.526H46.1376V114.422Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.241 114.422H46.1376V117.526H49.241V114.422Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.5512 114.422H55.4478V117.526H58.5512V114.422Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.6546 114.422H58.5512V117.526H61.6546V114.422Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.758 114.422H61.6546V117.526H64.758V114.422Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.8615 114.422H64.758V117.526H67.8615V114.422Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.0683 114.422H70.9649V117.526H74.0683V114.422Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.2751 114.422H77.1717V117.526H80.2751V114.422Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.482 114.422H83.3785V117.526H86.482V114.422Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.206 114.422H105.102V117.526H108.206V114.422Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.413 114.422H111.309V117.526H114.413V114.422Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.826 114.422H123.723V117.526H126.826V114.422Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.033 114.422H129.93V117.526H133.033V114.422Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1034 117.526H12V120.629H15.1034V117.526Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.2068 117.526H15.1034V120.629H18.2068V117.526Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.3102 117.526H18.2068V120.629H21.3102V117.526Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.4137 117.526H21.3102V120.629H24.4137V117.526Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.5171 117.526H24.4137V120.629H27.5171V117.526Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.6205 117.526H27.5171V120.629H30.6205V117.526Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.7239 117.526H30.6205V120.629H33.7239V117.526Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.1376 117.526H43.0341V120.629H46.1376V117.526Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.3444 117.526H49.241V120.629H52.3444V117.526Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.4478 117.526H52.3444V120.629H55.4478V117.526Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.8615 117.526H64.758V120.629H67.8615V117.526Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.0683 117.526H70.9649V120.629H74.0683V117.526Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.3785 117.526H80.2751V120.629H83.3785V117.526Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.482 117.526H83.3785V120.629H86.482V117.526Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.5854 117.526H86.482V120.629H89.5854V117.526Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.6888 117.526H89.5854V120.629H92.6888V117.526Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.7922 117.526H92.6888V120.629H95.7922V117.526Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.8956 117.526H95.7922V120.629H98.8956V117.526Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.102 117.526H101.999V120.629H105.102V117.526Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.309 117.526H108.206V120.629H111.309V117.526Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.413 117.526H111.309V120.629H114.413V117.526Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.62 117.526H117.516V120.629H120.62V117.526Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.826 117.526H123.723V120.629H126.826V117.526Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.033 117.526H129.93V120.629H133.033V117.526Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.137 117.526H133.033V120.629H136.137V117.526Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.24 117.526H136.137V120.629H139.24V117.526Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1034 120.629H12V123.733H15.1034V120.629Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.7239 120.629H30.6205V123.733H33.7239V120.629Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.1376 120.629H43.0341V123.733H46.1376V120.629Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.3444 120.629H49.241V123.733H52.3444V120.629Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.5512 120.629H55.4478V123.733H58.5512V120.629Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.6546 120.629H58.5512V123.733H61.6546V120.629Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.758 120.629H61.6546V123.733H64.758V120.629Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.8615 120.629H64.758V123.733H67.8615V120.629Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.9649 120.629H67.8615V123.733H70.9649V120.629Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.2751 120.629H77.1717V123.733H80.2751V120.629Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.6888 120.629H89.5854V123.733H92.6888V120.629Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.8956 120.629H95.7922V123.733H98.8956V120.629Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.102 120.629H101.999V123.733H105.102V120.629Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.309 120.629H108.206V123.733H111.309V120.629Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.413 120.629H111.309V123.733H114.413V120.629Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.826 120.629H123.723V123.733H126.826V120.629Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.93 120.629H126.826V123.733H129.93V120.629Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.033 120.629H129.93V123.733H133.033V120.629Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.24 120.629H136.137V123.733H139.24V120.629Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1034 123.733H12V126.836H15.1034V123.733Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.3102 123.733H18.2068V126.836H21.3102V123.733Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.4137 123.733H21.3102V126.836H24.4137V123.733Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.5171 123.733H24.4137V126.836H27.5171V123.733Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.7239 123.733H30.6205V126.836H33.7239V123.733Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.0341 123.733H39.9307V126.836H43.0341V123.733Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.241 123.733H46.1376V126.836H49.241V123.733Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.4478 123.733H52.3444V126.836H55.4478V123.733Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.5512 123.733H55.4478V126.836H58.5512V123.733Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.8615 123.733H64.758V126.836H67.8615V123.733Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.9649 123.733H67.8615V126.836H70.9649V123.733Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.0683 123.733H70.9649V126.836H74.0683V123.733Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.2751 123.733H77.1717V126.836H80.2751V123.733Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.482 123.733H83.3785V126.836H86.482V123.733Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.6888 123.733H89.5854V126.836H92.6888V123.733Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.7922 123.733H92.6888V126.836H95.7922V123.733Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.102 123.733H101.999V126.836H105.102V123.733Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.413 123.733H111.309V126.836H114.413V123.733Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.516 123.733H114.413V126.836H117.516V123.733Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.62 123.733H117.516V126.836H120.62V123.733Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.723 123.733H120.62V126.836H123.723V123.733Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.826 123.733H123.723V126.836H126.826V123.733Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.033 123.733H129.93V126.836H133.033V123.733Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.137 123.733H133.033V126.836H136.137V123.733Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.24 123.733H136.137V126.836H139.24V123.733Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1034 126.836H12V129.94H15.1034V126.836Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.3102 126.836H18.2068V129.94H21.3102V126.836Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.4137 126.836H21.3102V129.94H24.4137V126.836Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.5171 126.836H24.4137V129.94H27.5171V126.836Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.7239 126.836H30.6205V129.94H33.7239V126.836Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.241 126.836H46.1376V129.94H49.241V126.836Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.4478 126.836H52.3444V129.94H55.4478V126.836Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.6546 126.836H58.5512V129.94H61.6546V126.836Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.0683 126.836H70.9649V129.94H74.0683V126.836Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.2751 126.836H77.1717V129.94H80.2751V126.836Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.3785 126.836H80.2751V129.94H83.3785V126.836Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.482 126.836H83.3785V129.94H86.482V126.836Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.5854 126.836H86.482V129.94H89.5854V126.836Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.6888 126.836H89.5854V129.94H92.6888V126.836Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.8956 126.836H95.7922V129.94H98.8956V126.836Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.999 126.836H98.8956V129.94H101.999V126.836Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.309 126.836H108.206V129.94H111.309V126.836Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.62 126.836H117.516V129.94H120.62V126.836Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.723 126.836H120.62V129.94H123.723V126.836Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.826 126.836H123.723V129.94H126.826V126.836Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.93 126.836H126.826V129.94H129.93V126.836Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.033 126.836H129.93V129.94H133.033V126.836Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.137 126.836H133.033V129.94H136.137V126.836Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1034 129.94H12V133.043H15.1034V129.94Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.3102 129.94H18.2068V133.043H21.3102V129.94Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.4137 129.94H21.3102V133.043H24.4137V129.94Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.5171 129.94H24.4137V133.043H27.5171V129.94Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.7239 129.94H30.6205V133.043H33.7239V129.94Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.4478 129.94H52.3444V133.043H55.4478V129.94Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.5512 129.94H55.4478V133.043H58.5512V129.94Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.6546 129.94H58.5512V133.043H61.6546V129.94Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.758 129.94H61.6546V133.043H64.758V129.94Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.9649 129.94H67.8615V133.043H70.9649V129.94Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.1717 129.94H74.0683V133.043H77.1717V129.94Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.8956 129.94H95.7922V133.043H98.8956V129.94Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.999 129.94H98.8956V133.043H101.999V129.94Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.413 129.94H111.309V133.043H114.413V129.94Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.93 129.94H126.826V133.043H129.93V129.94Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.033 129.94H129.93V133.043H133.033V129.94Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.137 129.94H133.033V133.043H136.137V129.94Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.24 129.94H136.137V133.043H139.24V129.94Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1034 133.043H12V136.146H15.1034V133.043Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.7239 133.043H30.6205V136.146H33.7239V133.043Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.9307 133.043H36.8273V136.146H39.9307V133.043Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.9649 133.043H67.8615V136.146H70.9649V133.043Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.0683 133.043H70.9649V136.146H74.0683V133.043Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.482 133.043H83.3785V136.146H86.482V133.043Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.7922 133.043H92.6888V136.146H95.7922V133.043Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.102 133.043H101.999V136.146H105.102V133.043Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.309 133.043H108.206V136.146H111.309V133.043Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.93 133.043H126.826V136.146H129.93V133.043Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.033 133.043H129.93V136.146H133.033V133.043Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1034 136.146H12V139.25H15.1034V136.146Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.2068 136.146H15.1034V139.25H18.2068V136.146Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.3102 136.146H18.2068V139.25H21.3102V136.146Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.4137 136.146H21.3102V139.25H24.4137V136.146Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.5171 136.146H24.4137V139.25H27.5171V136.146Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.6205 136.146H27.5171V139.25H30.6205V136.146Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.7239 136.146H30.6205V139.25H33.7239V136.146Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.9307 136.146H36.8273V139.25H39.9307V136.146Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.241 136.146H46.1376V139.25H49.241V136.146Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.4478 136.146H52.3444V139.25H55.4478V136.146Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.6546 136.146H58.5512V139.25H61.6546V136.146Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.8615 136.146H64.758V139.25H67.8615V136.146Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.9649 136.146H67.8615V139.25H70.9649V136.146Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.482 136.146H83.3785V139.25H86.482V136.146Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.6888 136.146H89.5854V139.25H92.6888V136.146Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.999 136.146H98.8956V139.25H101.999V136.146Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.102 136.146H101.999V139.25H105.102V136.146Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.206 136.146H105.102V139.25H108.206V136.146Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.93 136.146H126.826V139.25H129.93V136.146Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.137 136.146H133.033V139.25H136.137V136.146Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_833_41129"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 152.02,
    height: 152.02,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayQr);
export default __webpack_public_path__ + "static/media/play-qr.4177844a31b88f716b3c9a0c897052f6.svg";
export { ForwardRef as ReactComponent };